module.exports = __webpack_public_path__ + "static/media/02.021.92fcae48.jpg";